import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface SensorIdentityFieldsProps {
  name: string;
  customid: string;
  input_number: string;
  onChange: (field: string, value: string) => void;
}

export function SensorIdentityFields({
  name,
  customid,
  input_number,
  onChange,
}: SensorIdentityFieldsProps) {
  return (
    <div className="space-y-3">
      <h4 className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
        Identity
      </h4>
      <div>
        <Label htmlFor="sensor-name">
          Name <span className="text-destructive">*</span>
        </Label>
        <Input
          id="sensor-name"
          value={name}
          onChange={(e) => onChange('name', e.target.value)}
          placeholder="Sensor name"
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label htmlFor="sensor-customid">Custom ID</Label>
          <Input
            id="sensor-customid"
            value={customid}
            onChange={(e) => onChange('customid', e.target.value)}
            placeholder="Optional"
          />
        </div>
        <div>
          <Label htmlFor="sensor-input-number">Input #</Label>
          <Input
            id="sensor-input-number"
            value={input_number}
            onChange={(e) => onChange('input_number', e.target.value.slice(0, 4))}
            placeholder="Optional"
            maxLength={4}
          />
        </div>
      </div>
    </div>
  );
}
